import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { CountriesRedux } from '../Redux/CountriesRedux'

const countriesCrudObservable = createCRUDObservable({
  mainRedux: CountriesRedux,
  reduxPath: 'countries',
})

export const countriesObservers = Object.assign({}, countriesCrudObservable.observers, {})

export const countriesEpic = combineEpics(
  countriesCrudObservable.epic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/CountriesObservable.js